module.exports = __webpack_public_path__ + "static/media/diamond1.b8c62e5c.png";